<template>
  <Card :padding="5"    dis-hover :bordered="false"  :style="'background:#eee;height:' + clientHeight +'px'">
    <div class="efutre-report" tabindex="0" @keydown.ctrl.shift.alt.65="downSql">
    <Card ref="toolbarcard" :padding="0" style="margin-bottom: 5px;" dis-hover>
        <Row type="flex" justify="start" align="middle"  style="padding:5px 10px" >
            <Col  span='18'>
               <ButtonToolBar  ref="menutoolbar" style="margin-left: -8px;" :config="menuToolbar"  :moduleMethod="moduleMethod" justify="start" @doAction="doAction"/>
            </Col>
            <Col span="6"  >
                <Row type="flex" justify="end" align="middle">
                    <PromptMessage/>
                </Row>
            </Col>
        </Row>
    </Card>
    <Card ref="formcard" v-show="showSearchPara" :padding="0"  dis-hover :bordered="true">
        <FormCardBox  ref="form"  :config="myConfig.formConfig" :dictData="dictData" @on-open-change="onOpenChange"/>
    </Card>
    <Card ref="bread" :padding="12" dis-hover style="margin-top: 5px;margin-bottom: 5px;" >
        <Row type="flex" justify="start" align="middle" >
        <Col span="20">
        <Breadcrumb >
            <BreadcrumbItem v-for="(temp,index) in levelData" to="click" :key="index" @click="levelClik(temp)">{{temp.name}}</BreadcrumbItem>
        </Breadcrumb>
        </Col>
         <Col span="4"  >
                <Row type="flex" justify="end" align="middle">
                     <Button type="text" size="small" @click="hideSearchPara()">查询条件</Button>
                </Row>
            </Col>
        </Row>
    </Card>
    <Card :padding="0" :bordered="false" dis-hover>
        <ViewGrid v-if="reset" ref="grid" :config="gridConfig"  :dictData="dictData" @dbclick="dbclick" />
    </Card>
    </div>
  </Card>
</template>

<script>
import PromptMessage from './promptmessage.vue';
import ButtonToolbar from './btntoolbar.vue';
export default {
    name:'levelreport',
    components:{PromptMessage, ButtonToolbar},
    data () {
        return {
            levelName:'level',
            levelIdName:'levelid',
            levelFidName:'levelfid',
            levelTextName:'levelname',
            levelData:[],
            initLevelData:[],
            myConfig:{
                titleType:2,
                divStyle:'padding:5px',
                title:'查询条件'
            },
            menuToolbar:{},
            gridToolbar:{},
            frontBtn:[{
                name:'searchData', text:'查询'
            }, {
                name:'clearData', text:'清除'
            }],
            oldLevelidSearchBefore:null,
            showSearchPara:true,
            reset:true,
            resetGridFlag:false
        };
    },
    props:{
        config:{
            type:Object,
            default:null
        },
        dictData:{
            type:Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default:() => {
                return [];
            }
        }
    },
    computed:{
        clientHeight () {
            return this.$Store.state.app.clientHeight;
        },
        gridConfig () {
            let num = this.levelData.length;
            if (num === 0) {
                return this.$Method.copy(this.myConfig.gridConfig);
            } else {
                if (this.levelData[num - 1].gridName) {
                    return this.$Method.copy(this.myConfig[this.levelData[num - 1].gridName]);
                } else {
                    return this.$Method.copy(this.myConfig.gridConfig);
                }
            }
        }
    },
    created () {
        this.myConfig = Object.assign({}, this.myConfig, this.config);
        if (this.myConfig.levelIdName) {
            this.levelIdName = this.myConfig.levelIdName;
        }
        if (this.myConfig.levelFidName) {
            this.levelFidName = this.myConfig.levelFidName;
        }
        if (this.myConfig.levelTextName) {
            this.levelTextName = this.myConfig.levelTextName;
        }
        if (this.myConfig.levelName) {
            this.levelName = this.myConfig.levelName;
        }
        this.initGridMyConfig('gridConfig');
        this.myConfig.formConfig.titleType = this.myConfig.titleType;
        if (this.myConfig.formConfig.title === undefined) {
            this.myConfig.formConfig.title = this.myConfig.title;
        }
        this.myConfig.formConfig.divStyle = this.myConfig.divStyle;
        this.myConfig.formConfig.showBtn = false;
        this.myConfig.formConfig.hide = true;
        this.myConfig.formConfig.disHover = true;
        if (this.myConfig.menuToolbar && this.myConfig.menuToolbar.items) {
            this.menuToolbar = this.$Method.copy(this.myConfig.menuToolbar);
        }
        let index = this.myConfig.formConfig.items.findIndex(el => el.name === this.levelIdName);
        if (index > -1) {
            if (this.myConfig.formConfig.items[index].searchBefore) {
                this.oldLevelidSearchBefore = this.myConfig.formConfig.items[index].searchBefore;
            }
            if (!this.myConfig.formConfig.items[index].textName) {
                this.myConfig.formConfig.items[index].textName = this.levelTextName;
            }
            this.myConfig.formConfig.items[index].searchBefore = this.levelidSearchBefore;
        }
        if (this.myConfig.initLevelData !== undefined) {
            this.initLevelData = this.$Method.copy(this.myConfig.initLevelData);
        }
        if (this.initLevelData.length > 0) {
            this.levelData.push(this.$Method.copy(this.initLevelData[0]));
        }
        let obj = {};
        this.initLevelData.forEach(el => {
            if (el.gridName && el.gridName !== 'gridConfig') {
                if (!obj[el.gridName]) {
                    obj[el.gridName] = {};
                    this.initGridMyConfig(el.gridName);
                    if (!this.resetGridFlag) {
                        this.resetGridFlag = true;
                    }
                }
            }
        });
    },
    methods:{
        initGridMyConfig (name) {
            this.myConfig[name].headStyle = '';
            this.myConfig[name].showCondition = false;
            this.myConfig[name].onSelectionChange = this.gridOnSelectionChange;
            if (this.myConfig[name].resources === undefined) {
                this.myConfig[name].resources = this.config.resources;
            }
            if (this.myConfig[name].method === undefined) {
                this.myConfig[name].method = this.config.classPrefix + '.' + 'query';
            }
            if (this.myConfig[name].response === undefined) {
                this.myConfig[name].response = this.config.response;
            }
            this.myConfig[name].height = 1;
            this.myConfig[name].width = 1;
            this.myConfig[name].adjustHeight = 0;
            this.myConfig[name].adjustWidth = 0;

            if (this.myConfig[name].pageSizeNum === undefined) {
                this.myConfig[name].pageSizeNum = 20;
            }
            this.myConfig[name].items.forEach(el => {
                if (el.type !== 'CheckBox') {
                    if (el.tooltip === undefined) {
                        el.tooltip = true;
                    }
                }
            });
        },
        levelClik (temp) {
            let last = this.levelData.length - 1;
            let index = this.levelData.findIndex(el => el[this.levelIdName] === temp[this.levelIdName]);
            if (last === index) {
                return false;
            }
            if (index > -1) {
                this.levelData.splice(index, last - index);
            }
            let curlIndex = -1;
            if (this.levelData.length > 0) {
                curlIndex = this.levelData.length - 1;
            }
            if (curlIndex > -1) {
                let preLevel = this.$Method.copy(this.initLevelData[curlIndex]);
                if (temp[this.levelFidName]) {
                    preLevel[this.levelFidName] = temp[this.levelFidName];
                }
                this.levelData.splice(curlIndex, 1, preLevel);
                if (this.resetGridFlag) {
                    this.reset = false;
                    this.$nextTick(() => {
                        this.reset = true;
                        this.$nextTick(() => {
                            this.setGridHeight();
                            this.doCommonLevelChange();
                        });
                    });
                } else {
                    this.doCommonLevelChange();
                }
            } else {
                return false;
            }
        },
        doCommonLevelChange () {
            let num = this.levelData.length - 1;
            this.$refs.grid.updateColPro(this.levelTextName, {label:this.initLevelData[num].name});
            if (num === 0) {
                this.$refs.menutoolbar.setReadOnly('clearData', false);
            } else {
                this.$refs.menutoolbar.setReadOnly('clearData', true);
            }
            let obj = [];
            let tempLevelConfig = {};
            this.myConfig.formConfig.items.forEach(el => {
                if (el.required || el.notLevelFlag) {
                    let temp = {};
                    if (el.name) {
                        temp.name = el.name;
                    } else {
                        if (el.sname) {
                            temp.name = el.sname;
                        }
                    }
                    if (num === 0) {
                        temp.readOnly = false;
                        if (el.required !== undefined) {
                            temp.required = true;
                        }
                    } else {
                        temp.readOnly = true;
                        if (el.required !== undefined) {
                            temp.required = false;
                        }
                    }
                    obj.push(temp);
                }
                if (el.name === this.levelIdName) {
                    Object.assign(tempLevelConfig, el);
                }
            });
            if (this.initLevelData[num].levelConfig) {
                Object.assign(tempLevelConfig, this.initLevelData[num].levelConfig);
            }
            tempLevelConfig.label = this.initLevelData[num].name;
            obj.push(tempLevelConfig);
            this.$refs.form.updateItemsConfig(obj);
            this.$nextTick(() => {
                this.$refs.form.setValue(this.levelIdName, '');
                this.$refs.form.setValue(this.levelTextName, '');
                this.searchData();
            });
        },
        levelidSearchBefore (that, obj) {
            if (this.oldLevelidSearchBefore) {
                let flag = this.oldLevelidSearchBefore(that, obj);
                if (flag) {
                    if (!that.searchParam) {
                        that.searchParam = {};
                    }
                    Object.assign(that.searchParam, this.getLevelPara(true));
                }
                return flag;
            } else {
                if (!that.searchParam) {
                    that.searchParam = {};
                }
                Object.assign(that.searchParam, this.getLevelPara(true));
            }
            return true;
        },
        doMenuToolbar () {
            if (this.$refs.menutoolbar) {
                this.$refs.menutoolbar.addBtnObject(this.frontBtn, 'front');
            }
        },
        doAction (obj) {
            const method = obj.name;
            if (this.$parent[method]) {
                this.$parent[method]();
            } else {
                if (this[method]) {
                    this[method]();
                }
            }
        },
        downSql () {
            this.$nextTick(() => {
                this.exportSql();
            });
            // console.log(1);
        },
        clearData () {
            this.$refs.form.clearData();
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.clearData();
        },
        searchData () {
            this.$refs.form.checkValidate();
            let flag = this.$refs.form.isError();
            if (flag) {
                this.alert('必填项不允许为空');
                return false;
            }
            let data = this.$refs.form.getData();
            let searchParam = {};
            for (let pro in data) {
                if (data[pro] || data[pro] === 0) {
                    searchParam[pro] = data[pro];
                }
            }
            Object.assign(searchParam, this.getLevelPara());
            this.$refs.grid.clearSearchBeforeSearchParam();
            this.$refs.grid.setSearchBeforeSearchParam(searchParam);
            this.$refs.grid.refurbish();
        },
        getLevelPara (flag) {
            let para = {};
            if (this.levelData.length > 0) {
                let num = this.levelData.length - 1;
                if (this.levelData[num][this.levelName]) {
                    para[this.levelName] = this.levelData[num][this.levelName];
                }
                if (this.levelData[num][this.levelFidName]) {
                    para[this.levelFidName] = this.levelData[num][this.levelFidName];
                }
            }
            if (this.myConfig.customSearchParam) {
                return this.myConfig.customSearchParam(this.levelData, para, flag);
            } else {
                return para;
            }
        },
        exportData () {
            let data = this.$refs.grid.getData();
            if (data.length === 0) {
                this.alert('请先查询数据');
                return false;
            }
            this.$refs.grid.export();
        },
        exportSql () {
            let _param = this.$refs.grid.getSearchParam();
            let moduleCode = this.getModulecode();
            if (moduleCode) {
                _param.moduleCode = moduleCode;
            } else {
                this.alert('模块号不能为空');
                return;
            }
            let data = this.$refs.form.getData();
            for (let pro in data) {
                if (data[pro] || data[pro] === 0) {
                    _param[pro] = data[pro];
                }
            }
            let _baseUrl = this.myConfig.gridConfig.resources.replace('rest', 'exportReportInfo');
            let _self = this;
            this.doExportReport(_baseUrl, this.config.classPrefix + '.getrptinfo', _param, _self);
        },
        refurbish () {
            this.searchData();
        },
        getGrid () {
            return this.$refs.grid;
        },
        getForm () {
            return this.$refs.form;
        },
        onOpenChange (value) {
            this.setGridHeight(value);
        },
        setGridHeight (flag) {
            let height = this.clientHeight - this.$refs.toolbarcard.$el.clientHeight - this.$refs.bread.$el.clientHeight;
            if (this.showSearchPara) {
                height = height - this.$refs.formcard.$el.clientHeight;
            }
            if (!flag) {
                height = height - 50;
            }
            this.$refs.grid.setCalHeight(height);
        },
        dbclick (e) {
            let name = e[this.levelTextName];
            let num = this.levelData.length - 1;
            let nextLevelNum = num + 1;
            if (nextLevelNum >= this.initLevelData.length) {
                return;
            }
            let curl = {};
            curl[this.levelIdName] = e[this.levelIdName];
            if (this.levelData[num][this.levelFidName]) {
                curl[this.levelFidName] = this.levelData[num][this.levelFidName];
            }
            curl.name = name;
            this.levelData.splice(num, 1, curl);
            let nextLevel = this.$Method.copy(this.initLevelData[nextLevelNum]);
            nextLevel[this.levelFidName] = curl[this.levelIdName];
            this.levelData.push(nextLevel);
            if (this.resetGridFlag) {
                this.reset = false;
                this.$nextTick(() => {
                    this.reset = true;
                    this.$nextTick(() => {
                        this.setGridHeight();
                        this.doCommonLevelChange();
                    });
                });
            } else {
                this.doCommonLevelChange();
            }
        },
        hideSearchPara () {
            this.showSearchPara = !this.showSearchPara;
            this.$nextTick(() => {
                this.setGridHeight();
            });
        }
    },
    mounted () {
        this.doMenuToolbar();
        this.setGridHeight(true);
    }
};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/levelreport.vue